import React from 'react';
import queryString from 'query-string';
import { FormGroup } from 'react-bootstrap';
import { Button, ValidationError } from 'fw/components';
import { Form } from 'fw/forms';
import Loading from 'layouts/public/loading/Loading';
import Completed from 'layouts/public/completed/Completed';
import * as Notifications from 'fw/globals/Notifications';
import * as API from 'modules/app/API';

class UserUnsubscribe extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            error: null,
            loading: true,
            completed: false,
            loginIsEmpty: false
        }
    }

    retrieveUnsubscribe = () => {
        const rq = {
            unsubscribeToken: queryString.parse(this.props.location.search).p
        }

        API.Security.get('/registration/userUnsubscribe', rq,
            {
                success: (sr) => {
                   // Set initial state
                    this.setState({
                        loading: false,
                        data: {
                            name: sr.data.name,
                            unsubscribeFrom: sr.data.unsubscribeFrom
                        }
                    });
                },
                error: (sr) => {
                    this.setState({
                        loading: false,
                        error: sr.error
                    })
                }
            });
    }

    onCancel = () => {
        window.opener = null;
        window.open('', '_self');
        window.close();
    }

    completeUnsubscribe = () => {
        if (!this.validate())
            return;

        const rq = {
            unsubscribeToken: queryString.parse(this.props.location.search).p
        };

        API.Security.post('/registration/completeUserUnsubscribe', rq,
            {
                success: (sr) => {
                    this.setState({ completed: true });
                },
                error: (sr) => {
                    if (sr.error.erroCode === 'INVALID_TOKEN') {
                        this.setState({
                            loading: false,
                            error: sr.error
                        });
                    }
                    else
                        Notifications.error(sr.error.errorMessage);
                }
            });
    }

    validate() {
        return true;
    }

    componentDidMount() {
        this.retrieveUnsubscribe();
    }

    onSubmit = (form) => {
        this.completeUnsubscribe();
    }

    onChange = (form) => {
        this.setState({ form });
    }

    render() {
        if (this.state.loading) {
            return (<Loading />)
        }
        else if (this.state.error) {
            return <ValidationError error={this.state.error} />
        }
        else if (this.state.completed) {
            return (<Completed
                title="Unsubscribe complete."
                message="You will no longer receive VOCS notifications." />)
        }

        return (
            <React.Fragment>
                <p className="login-box-heading"> 
                    Please confirm that you no longer want to receive VOCS notifications for the {this.state.data.unsubscribeFrom} <strong>{this.state.data.name}</strong>.
                </p>
                <Form
                    onSubmit={this.onSubmit}
                    onChange={this.onChange}
                    values={this.state.form}>
                    <hr style={{ marginTop: "10px", marginBottom: "20px" }} />
                    <FormGroup className="text-center">
                        <Button id="btnCancel" onClick={this.onCancel} bsClass="btn btn-default btn-flat">Cancel</Button>
                        <Button style={{ marginLeft: "20px" }} id="btnFinish" type="submit" bsClass="btn btn-primary btn-flat">Confirm</Button>
                    </FormGroup>
                </Form>
            </React.Fragment>
        );
    }
}

export default UserUnsubscribe;



// WEBPACK FOOTER //
// ./src/areas/public/userUnsubscribe/UserUnsubscribe.js